module.exports = __webpack_public_path__ + "img/notify.91925832.svg";